import * as React from 'react';

import { Form } from 'antd';

import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice/appDeviceSlice';
import { DEVICES } from 'utils';

import ProductStepDesktop from './ProductStepDesktop';
import ProductStepMobile from './ProductStepMobile';

const ProductStep = ({
  form,
  query,
  setQuery,
  selectedProducts,
  setSelectedProducts,
  selectAllProducts,
  setSelectAllProducts,
  setTotalProduct,
  totalProduct,
}: ProductStepProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const [filterForm] = Form.useForm();
  const categoryList = useAppSelector(state => state.entityCategory.listAll);

  const myType = form.getFieldValue('type');
  const supplierID = form.getFieldValue('entityID');

  const dataFilter = [
    {
      name: 'entityCategoryID',
      list: categoryList,
      placeholder: 'Lọc theo danh mục',
    },
  ];

  React.useEffect(() => {
    const initData = (): void => {
      filterForm.setFieldsValue({
        entityCategoryID: query.entityCategoryID || 'all',
        name: query.name,
      });
    };
    initData();
  }, [filterForm, query.entityCategoryID, query.name]);

  const handleFilterFormChange = (e): void => {
    if (e.isObject) {
      return;
    }

    const [key] = Object.keys(e);
    const [value] = Object.values(e);

    if (value === 'all') {
      delete query[key];
      setQuery({ ...query });
    } else {
      setQuery({ ...query, ...e, page: 1 });
    }
  };

  const props = {
    myType,
    supplierID,
    dataFilter,
    handleFilterFormChange,
    selectedProducts,
    setSelectedProducts,
    selectAllProducts,
    setSelectAllProducts,
    setTotalProduct,
    totalProduct,
    filterForm,
    query,
    setQuery,
  };

  const renderElements = {
    [DEVICES.DESKTOP]: <ProductStepDesktop {...props} />,
    [DEVICES.MOBILE]: <ProductStepMobile {...props} />,
    [DEVICES.MOBILE]: <ProductStepMobile {...props} />,
  };

  return renderElements[appDevice.device];
};

export default ProductStep;

interface ProductStepProps {
  form;
  query: any;
  setQuery: (e: any) => void;
  selectedProducts: string[];
  setSelectedProducts: (value: string[]) => void;
  selectAllProducts: boolean;
  setSelectAllProducts: (value: boolean) => void;
  setTotalProduct: (value: number) => void;
  totalProduct: number;
}
